import React, { useEffect, useRef } from "react";
import Header from "./Components/Header";
import Footer from "./Components/Footer";
import Icons from "./Common/IconsGroup";
import "./Styles.css";
import "./AboutUs.css";
import { useLocation } from "react-router-dom";

// const ABOUT_US_QUESTIONS = [
//   {ƒ
//     question: "Who We Are",
//     answer: "Utvyakta Solutions is a technology company focused on industrial IoT and AI-driven optimization. We specialize in making industrial equipment smarter, more efficient, and connected."
//   },
//   {
//     question: "Our Mission",
//     answer: "To digitize and optimize industrial equipment worldwide, starting with compressed air systems - helping businesses reduce energy consumption, prevent downtime, and achieve sustainability goals."
//   },
//   {
//     question: "Our Expertise",
//     answer: "Deep domain knowledge in compressed air systems, industrial automation, IoT connectivity, and AI-powered predictive analytics."
//   },
//   {
//     question: "Global Reach",
//     answer: "Serving customers across 5+ countries with 2000+ connected compressors and 30+ OEM/service partners."
//   },
// ];

const GLOBAL_ADVISORS = [
  {
    img: require("./images/advisors_1.png"),
    name: "Håkan Kingstedt",
    // info: "Senior Advisor",
    info: "Chairman of Sweden-India Business Council (SIBC) and Former President of Sandvik Ltd.",
    link: "https://www.linkedin.com/in/hakan-kingstedt-8670359/",
  },
  // {
  //   img: require("./images/advisors_2.png"),
  //   name: "Ravi Shankar Chaturvedi",
  //   info: "Director of Research, Fletcher School in Boston.",
  //   link: "https://www.linkedin.com/in/rscvedi/"
  // },
  {
    img: require("./images/advisor3.png"),
    name: "Mathi Gurusamy",
    // role: "Chief Strategy & Product Officer, Lantronix",
    info: "Chief Strategy & Product Officer, Lantronix",
    // info: "Industry Expert & Strategic Advisor.",
    link: "https://www.linkedin.com/in/mathi-gurusamy-69782a1/",
  },
  {
    img: require("./images/advisor_7.jpg"),
    name: "Karthikeyan Natarajan",
    // role: "",
    info: "Former CEO & Executive Director @Cyient",
    link: "https://www.linkedin.com/in/iamkarthiknatarajan/",
  },
  // {
  //   img: require("./images/advisors_4.png"),
  //   name: "Murali Rajagopalan",
  //   info: "Strategic Business Advisor.",
  //   link: "https://www.linkedin.com/in/mrajagopalan1/"
  // },
  // {
  //   img: require("./images/advisors_5.png"),
  //   name: "IIkka Hakala",
  //   info: "International Business Advisor.",
  //   link: "https://www.linkedin.com/in/ilkka-hakala-6923992a/"
  // },
  // {
  //   img: require("./images/advisors_6.png"),
  //   name: "Bhagya Chandra Rao",
  //   info: "Former Managing Director of Kennametal India Limited; Former President, Sandvik Mining & Construction Rock Tools.",
  //   link: "https://www.linkedin.com/in/b-c-rao-b9142886/"
  // }
];

const LEADERSHIP_TEAM = [
  {
    img: require("./images/team_1.png"),
    role: "Founder & Managing Director",
    name: "Akshay Ramachandran",
    // info: "Sales, Management & dev experience across India & Europe.",
    link: "https://www.linkedin.com/in/akshay-ramachandran-97515342/",
  },
  {
    img: require("./images/team_2.png"),
    role: "CTO & Co-Founder",
    name: "Sudhir Ravindramohan",
    // info: "15 years of global experience across McWane & Oracle.",
    link: "https://www.linkedin.com/in/sudhirrpublicprofile/",
  },
  {
    img: require("./images/team_3.png"),
    role: "Co-Founder & Sales Director",
    name: "Frederik Vyncke",
    // info: "Leadership, Investments and sales experience globally.",
    link: "https://www.linkedin.com/in/frederikvyncke/",
  },
  {
    img: require("./images/team_4.png"),
    role: "Director - Projects",
    name: "Prasanna Venkatesh Raghavan",
    // info: "Product experience in ener gy management, automotive telematics & inventory management.",
    link: "https://www.linkedin.com/in/prasanna-venkatesh-raghavan-24438222/",
  },
];

const CORE_TEAM = [
  {
    img: require("./images/C_team_5.jpeg"),
    role: "Head of Human Resources",
    name: "Umamaheswari V",
    // info: "Manager HR & Admin with 13+ years experience in HR & Administration",
    link: "https://www.linkedin.com/in/uma-maheswari-venkat",
  },
  {
    img: require("./images/C_team_4.JPG"),
    role: "Sales & Field Associate",
    name: "Pratyush Kumar Rai",
    // info: "Dedicated to building strong customer relationships and driving growth across Gujarat and northern regions.",
    link: "https://www.linkedin.com/in/pratyush-rai-3222021b6",
  },
  {
    img: require("./images/team_13.png"),
    role: "Senior R&D Field Engineer",
    name: "Bharathiraj R",
    // info: "Backed by over 6 years of experience, focused on advancing R&D and delivering cutting-edge solutions.",
    link: "https://www.linkedin.com/in/bharathiraj-r-95b7251b6",
  },
  {
    img: require("./images/C_team_3.jpg"),
    role: "Senior R&D Field Engineer",
    name: "Pippin A",
    // info: "6+ years of R&D expertise driving innovation and field excellence.",
    link: "https://www.linkedin.com/in/pippin-ayyasamy-925240390",
  },
  {
    img: require("./images/C_team_2.png"),
    role: "Junior R&D Field Engineer",
    name: "Manish Raj D",
    // info: "Supporting innovation in the northern region through a hands-on approach to research and development.",
    link: "https://www.linkedin.com/in/manish-raj-singh-88990523b?utm_source=share_via&utm_content=profile&utm_medium=member_android",
  },
  {
    img: require("./images/C_team_7.jpg"),
    role: "Tech & Operation Lead",
    name: "Dhanashree M",
    // info: "Brings over 3 years of experience in technology and operations, leading teams to deliver efficient and scalable outcomes.",
    link: "https://www.linkedin.com/in/dhanashree-m-0350a1279",
  },
  {
    img: require("./images/C_team_8.jpg"),
    role: "Senior Software Engineer",
    name: "Poovarasan V",
    // info: "Skilled in developing reliable and robust software solutions, with over 3 years of industry experience.",
    link: "https://www.linkedin.com/in/poovarasan53",
  },
  {
    img: require("./images/C_team_6.jpg"),
    role: "Senior Software Engineer",
    name: "Mohammed Rasul M",
    // info: "A technology enthusiast with over 3 years of experience in software development, delivering impactful solutions.",
    link: "https://www.linkedin.com/in/mohammedrasul",
  },
  {
    img: require("./images/C_team_9.png"),
    role: "Operations Executive",
    name: "Jenifa Mary A",
    // info: "Backed by 4+ years in operations and MIS, delivers streamlined processes and enhances organizational efficiency.",
    link: "https://www.linkedin.com/in/jenifa-mary-a-9458b8217",
  },
  {
    img: require("./images/C_team_1.png"),
    role: "Junior Data Analyst Engineer",
    name: "Anil Kumar D",
    // info: "Enthusiastic junior data analyst, bringing 1 year of hands-on experience.",
    link: "https://www.linkedin.com/in/anilreddy715",
  },
];

const INDUSTRY_NUMBERS = [
  { count: "5+", label: "Countries"},
  { count: "2000+", label: "Compressors Monitored"},
  { count: "30+", label: "OEM/Service Partners"},
];

const Aboutus_Card = [
  {
    icon: Icons(30, 30,"#457ec9ff").building(),
    ClassIcon: "icon-bg-blue",
    "title": "Who We Are",
    "info": "Utvyakta Solutions is a technology company focused on Industrial IoT and AI-driven optimization. We specialize in making industrial equipment smarter, more efficient, and connected."
  },
  {
    icon: Icons(30, 30,"#2deb6fff").circleTick(),
    ClassIcon: "icon-bg-green",
    "title": "Our Mission",
    "info": "To digitize and optimize industrial equipment worldwide, starting with compressed air systems - helping businesses reduce energy consumption, prevent downtime, and achieve sustainability goals."
  },
  { 
    icon: Icons(30, 30,"#9333EA").idea(),
    ClassIcon: "icon-purple-bg",
    "title": "Our Expertise",
    "info": "Deep domain knowledge in compressed air systems, industrial automation, IoT connectivity and AI-powered predictive analytics."
  } 
];

const Middle_Banner = [
  {
    icon: Icons(40, 40).currentCircle(),
    iconClass: "iot-icon-bg",
    title : "IoT Connectivity",
    info : "Real-Time Monitoring and Control",
  },
  { 
    icon: Icons(40, 40).pendrive(),
    iconClass: "ai-icon-bg",
    title : "AI Analytics",
    info : "Predictive Maintenance Insights",
  },
  {
    icon: Icons(40, 40).loading(),
    iconClass: "opt-icon-bg",
    title : "Optimization",
    info : "Energy Efficiency Solutions",
  },
  {
    icon: Icons(40, 40).star(),
    iconClass: "sus-icon-bg",
    title : "Sustainability",
    info : "Reducing Carbon Footprint",
 }
];

function AboutUs() {
  const location = useLocation();
  const aboutUsPageRefs = {
    about: useRef(),
    advisors: useRef(),
    achivements: useRef(),
    leadership: useRef(),
    coreTeam: useRef(),
    aboutbanner: useRef(),
  };

  useEffect(() => {
    let ref = aboutUsPageRefs[location.state?.scrollTo];
    console.log("oooooooooooo", ref);
    if (ref && ref.current) {
      const y =
        ref.current.getBoundingClientRect().top + window.pageYOffset - 150;
      window.scrollTo({ top: y, behavior: "smooth" });
    }
    //eslint-disable-next-line
  }, [location]);

  return (
    <React.Fragment>
      <Header />

      {/* <div
        className="container-fluid solutions-bg about-us-banner"
        id="aboutus"
        style={{ paddingTop: "50px" }}
        ref={aboutUsPageRefs.about}
      >
        <div className="d-flex flex-column about-banner-container">
          <span className="green-para">About Utvyakta Solutions</span>
          <div className="about-banner-content-container">
            <div className="about-banner-questions-container">
              {ABOUT_US_QUESTIONS.map((data) => {
                return(
                  <div className="about-banner-question-answer">
                    <span className="about-banner-question">{data.question}</span>
                    <span className="about-banner-answer">
                      {data.answer}
                    </span>
                  </div>
                )
              })}
            </div>
          </div>

          <div className="row" style={{ justifyContent: "center" }}>
            <div className="col-md-10 col-sm-12 text-center">
              <p className="para green-para">
                A vision to reduce carbon emission.
              </p>
              <p
                className="para solution-banner-para"
                style={{ fontSize: "1.1em" }}
              >
                We are on a mission to make industries energy efficient through
                better monitoring and maintenance of machines. Our focus is to
                bring world-class solutions to businesses in a cost-effective
                manner, enabling a growing number of global manufacturers to
                adopt digital technologies to drive operational efficiencies at
                their plants.
              </p>
              <p
                className="para solution-banner-para"
                style={{ fontSize: "1.1em" }}
              >
                Headquartered in India, we have offices in Coimbatore, Bangalore
                and Stockholm (Europe). Our aspiration is make a tangible impact
                on the planet by developing cost effective energy solutions. We
                are proud to align with the UN SDG Goal industries, innovation
                and infrastructure.
              </p>
            </div>
          </div>
        </div>
      </div> */}

      <div
        ref={aboutUsPageRefs.aboutbanner}
        className="about-us-banner-container"
      >
        <div className="about-us-banner-title-container">
          <span className="about-us-banner-title">
            About Utvyakta Solutions
          </span>
          <span className="about-us-banner-sub-title">
            Pioneering the future of Industrial IoT and AI-driven optimization
          </span>         
        </div>
        <div className="about-us-banner-right-nested-child-counts-container">
          {INDUSTRY_NUMBERS.map((data) => {
            return (
              <div className="about-us-banner-right-nested-child-counts-content-container">
                <span className="about-us-count">{data.count}</span>
                <span className="about-us-count-label">{data.label}</span>
              </div>
              );
            })}
        </div>
      </div>

      <div className="about-us-card-section-parent-container">
        {Aboutus_Card.map((data)=>{
          return(
            <div className="about-us-card-section-child-container">        
              <div className={`about-us-card-section-icon ${data.ClassIcon}`}>
               {data.icon}
              </div>
              <h2 className="about-us-card-section-title">
                {data.title}
              </h2>
              <span className="about-us-card-section-info">
               {data.info}
              </span>
            </div>
          )
        })}
      </div>

      <div
        ref={aboutUsPageRefs.aboutbanner}
        className="middle-banner-container"
      >
        <div className="about-us-banner-title-container">
          <span className="about-us-banner-title">
            Powering Industrial Innovation
          </span>
        </div>
        <div className="about-us-middle-banner-container">
          {Middle_Banner.map((data)=>{
            return(
              <div className="about-us-middle-child-container">        
                <div className={`about-us-middle-section-icon ${data.iconClass}`}>
                  {data.icon}
                </div>
                <h2 className="about-us-middle-section-title">
                  {data.title}
                </h2>
                <span className="about-us-middle-section-info">
                  {data.info}
                </span>
              </div>
            )
          })
        }
        </div>
      </div>
          
        {/* <div className="about-us-banner-title-container">
          <span className="about-us-banner-title">
            About Utvyakta Solutions
          </span>
          <span className="about-us-banner-sub-title">
            Pioneering the future of Industrial IoT and AI-driven optimization
          </span>
        </div>
        <div className="about-us-banner-child-container">
          <div className="about-us-banner-left-container">
            <span className="about-us-banner-left-title">Who We Are</span>
            <span className="about-us-banner-left-sub-title">
              Utvyakta Solutions is a technology company focused on Industrial
              IoT and AI-driven optimization. We specialize in making industrial
              equipment smarter, more efficient, and connected.
            </span>
            <div className="about-us-banner-left-nested-child-container">
              <span className="about-us-banner-left-nested-child-title">
                Our Mission
              </span>
              <span className="about-us-banner-left-nested-child-sub-title">
                To digitize and optimize industrial equipment worldwide,
                starting with compressed air systems - helping businesses reduce
                energy consumption, prevent downtime, and achieve sustainability
                goals.
              </span>
            </div>
          </div>
          <div className="about-us-banner-right-container">
            <span className="about-us-banner-right-title">Our Expertise</span>
            <ul className="about-us-banner-right-list-container">
              <li>
                <div className="about-us-banner-right-list"></div>
                Deep domain knowledge in compressed air systems
              </li>
              <li>
                <div className="about-us-banner-right-list"></div>Industrial
                automation and IoT connectivity
              </li>
              <li>
                <div className="about-us-banner-right-list"></div>
                AI-powered predictive analytics
              </li>
            </ul>
            <div className="about-us-banner-right-nested-child-container">
              <span className="about-us-banner-right-nested-child-title">
                Global Reach
              </span>
              <div className="about-us-banner-right-nested-child-counts-container">
                {INDUSTRY_NUMBERS.map((data) => {
                  return (
                    <div className="about-us-banner-right-nested-child-counts-content-container">
                      <span className="about-us-count">{data.count}</span>
                      <span className="about-us-count-label">{data.label}</span>
                    </div>
                  );
                })}
              </div>
            </div>
          </div>
        </div> */}
      
      <div
        ref={aboutUsPageRefs.advisors}
        className="advisor-cards-content-container solutions-panel"
      >
        <div className="">
          <div
            className="about-us-team-header"
            style={{ marginBottom: "1rem" }}
          >
            <h1
              className="heading white-heading"
              style={{ padding: "50px 40px 0px 40px" }}
            >
              Board of Directors & Advisors to Leadership
            </h1>
            {/* <span className="para advisors-container-sub-title" style={{marginBottom: "5px"}}>Industry leaders guiding our strategic direction</span> */}
          </div>
        </div>

        <div className="advisor-cards-parent-container">
          {GLOBAL_ADVISORS.map((data) => {
            return (
             <div
                className="advisor-card-container-link advisor-card-content-container-link"
                style={{ all: "unset" }}
                href=""
              >
                <div className="advisor-card-content-container">
                  <a href={data.link} target="_blank" rel="noopener noreferrer">
                    <div className="advisor-card-linkedin-icon">
                      {Icons(20, 20, "#0077B5").Linkedin()} 
                    </div>
                  </a>
                  <div>
                    <img className="advisor-card-img" alt="" src={data.img} />
                  </div>
                  <div className="d-flex flex-column advisor-card-name-content-container">
                    <span className="advisor-card-content-name">
                      {data.name}
                    </span>
                    <span className="advisor-card-content-role">
                      {data.info}
                    </span>
                  </div>
                </div>
              </div>
            );
          })}
        </div>

        {/* <div className="row advisor">
          <div className="col col-md-4 col-sm-12 advisor-card">
            <div className="row">
              <div className="col-4">
                <img alt="" src={require("./images/advisors_1.png")} width="100%" />
              </div>
              <div className="col-7">
                <span className="advisor-naming">
                  <a
                    href="https://www.linkedin.com/in/hakan-kingstedt-8670359/"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    Håkan Kingstedt
                  </a>
                </span>
                <p className="para">
                  Chairman of Sweden-India Business Council (SIBC) and the
                  former president of Sandvik Ltd.
                </p>
              </div>
            </div>
          </div>

          <div className="col col-md-4 col-sm-12 advisor-card">
            <div className="row">
              <div className="col-4">
                <img alt="" src={require("./images/advisors_2.png")} width="100%" />
              </div>
              <div className="col-7">
                <span className="advisor-naming">
                  <a
                    href="https://www.linkedin.com/in/rscvedi/"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    Ravi Shankar Chaturvedi
                  </a>
                </span>
                <p className="para">
                  Director of Research, <br />
                  Fletcher School in Boston
                </p>
              </div>
            </div>
          </div>

          <div className="col col-md-4 col-sm-12 advisor-card">
            <div className="row">
              <div className="col-4">
                <img alt="" src={require("./images/advisor3.png")} width="100%" />
              </div>
              <div className="col-7">
                <span className="advisor-naming">
                  <a
                    href="https://www.linkedin.com/in/mathi-gurusamy-69782a1/"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    Mathi Gurusamy
                  </a>
                </span>
                <p className="para">
                  President &amp; CEO, <br />
                  Mobilogix Group
                </p>
              </div>
            </div>
          </div>

          <div className="col col-md-4 col-sm-12 margin-top20 advisor-card">
            <div className="row">
              <div className="col-4">
                <img alt="" src={require("./images/advisors_4.png")} width="100%" />
              </div>
              <div className="col-7">
                <span className="advisor-naming">
                  <a
                    href="https://www.linkedin.com/in/mrajagopalan1/"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    Murali Rajagopalan
                  </a>
                </span>
                <p className="para">
                  Managing Director, <br />
                  Mobilogix, India
                </p>
              </div>
            </div>
          </div>

          <div className="col col-md-4 col-sm-12 margin-top20 advisor-card">
            <div className="row">
              <div className="col-4">
                <img alt="" src={require("./images/advisors_5.png")} width="100%" />
              </div>
              <div className="col-7">
                <span className="advisor-naming">
                  <a
                    href="https://www.linkedin.com/in/ilkka-hakala-6923992a/"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    IIkka Hakala
                  </a>
                </span>
                <p className="para">
                  Co-owner, <br />
                  Karhula Foundry, Finland.
                </p>
              </div>
            </div>
          </div>

          <div className="col col-md-4 col-sm-12 margin-top20 advisor-card">
            <div className="row">
              <div className="col-4">
                <img alt="" src={require("./images/advisors_6.png")} width="100%" />
              </div>
              <div className="col-7">
                <span className="advisor-naming">
                  <a
                    href="https://www.linkedin.com/in/b-c-rao-b9142886/"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    Bhagya Chandra Rao
                  </a>
                </span>
                <p className="para">
                  Former Managing Director of Kennametal India Limited; Former
                  President, Sandvik mining &amp; construction Rock Tools
                </p>
              </div>
            </div>
          </div>
        </div> */}
      </div>

      {/* <div ref={aboutUsPageRefs.achivements} className="container-fluid grey-bg">
        <div className="">
          <div className="col-md-12 text-center brand-heading">
            Key Achievements
          </div>
          <div className="col-md-12 text-left">
            <div className="row" style={{ margin: "0 auto" }}>
              <div className="col-md-4 col-sm-12 achievements">
                <div className="white-box-container">
                  <span>
                    <img alt="" src={require("./images/achievement_1.png")} />
                  </span>
                  <h2 className="sub-heading" style={{ fontSize: "1.2em" }}>
                    <a
                      href="https://smartcompressor.utvyakta.com/login/login"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      Product market fit with compressor manufacturers,
                      distributors and industry end users
                    </a>
                  </h2>
                </div>
              </div>
              <div className="col-md-4 col-sm-12 achievements">
                <div className="white-box-container">
                  <span>
                    <img alt="" src={require("./images/achievement_2.png")} />
                  </span>
                  <h2 className="sub-heading" style={{ fontSize: "1.2em" }}>
                    <a
                      href="https://www.linkedin.com/posts/globalinnovationandtechnologyalliance_india-sweden-sustainabledevelopmentgoals-activity-6777840806993653760-UwtW/"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      Recipient of Indian-Sweden government grant from DST,
                      India and Vinnova, Sweden to build prototype for real-time
                      energy monitoring of foundries.
                    </a>
                  </h2>
                </div>
              </div>
              <div className="col-md-4 col-sm-12 achievements">
                <div className="white-box-container">
                  <span>
                    <img alt="" src={require("./images/achievement_3.png")} />
                  </span>
                  <h2 className="sub-heading" style={{ fontSize: "1.2em" }}>
                    <a
                      href="https://t-hub.co/raytheon-t-hub-rtxinnovationchallenge/"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      Among the top 3 of 80 finalists at T-Hub and Raytheon
                      Technologies Innovation challenged to build PoC for
                      quality inspection of Pratt &amp; Whitney 2500 engines.
                    </a>
                  </h2>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div> */}

      <div
        ref={aboutUsPageRefs.leadership}
        className="leadership-cards-content-container solutions-panel"
      >
        <div className="">
          <div
            className="about-us-team-header"
            style={{ marginBottom: "1rem" }}
          >
            <h1
              className="heading white-heading"
              style={{ padding: "50px 40px 0px 40px" }}
            >
              Leadership Team
            </h1>
            {/* <span className="para advisors-container-sub-title" style={{marginBottom: "5px"}}>Leadership & Core Team driving innovation</span> */}
          </div>
        </div>

        <div className="leader-ship-cards-content-container">
          {LEADERSHIP_TEAM.map((data) => {
            return (
              <div
                className="advisor-card-container-link"
                style={{ all: "unset" }}
                href=""
              >
                <div className="advisor-card-content-container">
                  <div>
                    <a href={data.link} target="_blank" rel="noopener noreferrer">
                      <div className="advisor-card-linkedin-icon">
                        {Icons(20, 20, "#0077B5").Linkedin()}
                      </div>
                    </a>
                    <img className="advisor-card-img" alt="" src={data.img} />
                  </div>
                  <div className="d-flex flex-column advisor-card-name-content-container">
                    <span className="advisor-card-name">{data.name}</span>
                    <span className="leader-ship-card-role">{data.role}</span>
                    <span className="advisor-card-name-info">{data.info}</span>
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      </div>

      <div className="aboutus-relative aboutus-z-10">
        <div className="aboutus-text-center aboutus-mb-8">
          <div className="aboutus-inline-flex aboutus-items-center aboutus-bg-green-100 aboutus-text-green-800 aboutus-px-4 aboutus-py-2 aboutus-rounded-full aboutus-text-sm aboutus-font-medium aboutus-mb-4">
            🌍 Global Collaboration
          </div>
          <h3 className="aboutus-global-title aboutus-text-3xl aboutus-font-bold aboutus-text-gray-900 aboutus-mb-6">
            Driving Industrial Sustainability Through Innovation
          </h3>
        </div>

        <div className="aboutus-grid aboutus-grid-cols-1 aboutus-lg:grid-cols-2 aboutus-gap-8 aboutus-items-center">
          <div className="aboutus-global-child-content">
            <p class="aboutus-global-info1 aboutus-text-lg aboutus-text-gray-700 aboutus-mb-6">
              Utvyakta Solutions is a deep-tech company focused on improving
              industrial energy efficiency through data and IoT. Our flagship
              platform, Kompress.ai, helps manufacturers reduce energy waste,
              emissions, and unplanned downtime through connected intelligence.
            </p>
            <p className="aboutus-global-info1 aboutus-text-lg aboutus-text-gray-700 aboutus-mb-8">
              Utvyakta is proud to be part of{" "}
              <strong className="aboutus-text-green-700">
                Third Derivative
              </strong>
              , a global collaborative climate-tech ecosystem that accelerates
              startups and moves markets toward a sustainable future.
            </p>
            <a
              href="https://www.third-derivative.org/portfolio/utvyakta-solutions"
              target="_blank"
              rel="noopener noreferrer"
              className="aboutus-global-btn aboutus-inline-flex aboutus-items-center aboutus-bg-green-600 aboutus-text-white aboutus-px-6 aboutus-py-3 aboutus-rounded-lg aboutus-font-semibold aboutus-hover:bg-green-700 aboutus-transition aboutus-duration-300 aboutus-transform aboutus-hover:scale-105"
            >
              Learn More About Our Partnership
              <svg
                className="aboutus-ml-2 aboutus-w-4 aboutus-h-4"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
              >
                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  stroke-width="2"
                  d="M10 6H6a2 2 0 00-2 2v10a2 2 0 002 2h10a2 2 0 002-2v-4M14 4h6m0 0v6m0-6L10 14"
                />
              </svg>
            </a>
          </div>

          <div className="aboutus-text-center">
            <div className="aboutus-bg-white aboutus-rounded-xl aboutus-p-8 aboutus-shadow-lg">
              <div className="aboutus-mb-4">
                {/* <div class="aboutus-w-32 aboutus-h-32 aboutus-mx-auto aboutus-bg-gradient-to-br aboutus-from-green-400 aboutus-to-blue-500 aboutus-rounded-full aboutus-flex aboutus-items-center aboutus-justify-center"> */}
                {/* <div class="aboutus-text-white aboutus-text-4xl aboutus-font-bold"> */}
                <img
                  className="aboutus-third-derivative-logo"
                  src={require("./images/third-derivative.png")}
                  alt=""
                />
                {/* </div> */}
                {/* </div> */}
              </div>
              {/* <h4 className="aboutus-global-title aboutus-text-xl aboutus-font-bold aboutus-text-gray-900 aboutus-mb-2">
                Third Derivative
              </h4> */}
              <p className="aboutus-global-info1 aboutus-text-gray-600 aboutus-text-sm aboutus-mb-4">
                Climate-Tech Accelerator
              </p>
              <div className="aboutus-flex aboutus-items-center aboutus-justify-center aboutus-space-x-4 aboutus-text-sm aboutus-text-gray-500">
                <div className="aboutus-flex aboutus-items-center">
                  <div className="aboutus-right-img-child aboutus-w-2 aboutus-h-2 aboutus-bg-green-500 aboutus-rounded-full aboutus-mr-2"></div>
                  <span className="aboutus-right-img-child-info1"> Portfolio Company</span>
                </div>
                <div className="aboutus-flex aboutus-items-center">
                  <div className="aboutus-w-2 aboutus-h-2 aboutus-bg-blue-500 aboutus-rounded-full aboutus-mr-2"></div>
                  <span className="aboutus-right-img-child-info1">Global Network</span>
                </div>
              </div>
            </div>

            <div className="aboutus-mt-6 aboutus-grid aboutus-grid-cols-2 aboutus-gap-4 aboutus-text-center">
              <div className="aboutus-bg-white aboutus-bg-opacity-70 aboutus-rounded-lg aboutus-p-4">
                <div className="aboutus-right-img-child-info1 aboutus-text-2xl aboutus-font-bold aboutus-text-green-600 aboutus-mb-1">
                  200+
                </div>
                <div className="aboutus-right-img-child-info1 aboutus-text-sm aboutus-text-gray-600">
                  Climate Startups
                </div>
              </div>
              <div className="aboutus-bg-white aboutus-bg-opacity-70 aboutus-rounded-lg aboutus-p-4">
                <div className="aboutus-right-img-child-info1 aboutus-text-2xl aboutus-font-bold aboutus-text-blue-600 aboutus-mb-1">
                  Global
                </div>
                <div className="aboutus-right-img-child-info1 aboutus-text-sm aboutus-text-gray-600">
                  Reach
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div
        ref={aboutUsPageRefs.coreTeam}
        className="core-team-cards-content-container solutions-panel"
      >
        <div className="">
          <div
            className="about-us-team-header"
            style={{ marginBottom: "1rem" }}
          >
            <h1
              className="heading white-heading"
              style={{ padding: "50px 40px 0px 40px" }}
            >
              Core Team
            </h1>
            {/* <span className="para" style={{marginBottom: "5px"}}>Leadership & Core Team driving innovation</span> */}
          </div>
        </div>

        <div className="core-team-grid-cards-content-container">
          {CORE_TEAM.map((data) => {
            return (
              <div
                className="advisor-card-container-link"
                style={{ all: "unset" }}
                href=""
              >
                <div className="advisor-card-content-container">
                  
                  <div>
                    <a href={data.link} target="_blank" rel="noopener noreferrer">
                      <div className="advisor-card-linkedin-icon">
                        {Icons(20, 20, "#0077B5").Linkedin()}
                      </div>
                    </a>

                    <img className="advisor-card-img" alt="" src={data.img} />
                  </div>
                  <div className="d-flex flex-column advisor-card-name-content-container">
                    <span className="advisor-card-name">{data.name}</span>
                    <span className="leader-ship-card-role">{data.role}</span>
                    <span className="advisor-card-name-info">{data.info}</span>
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      </div>

      {/* <div className="container">
        <div className="row row-reverse">
          <div className="col-md-6 col-sm-12 padding-50 mobile-left-padding">
            <h1
              className="heading white-heading mobile-only"
              style={{ padding: "10px 40px 30px 40px" }}
            >
              Custom R&amp;D solutions
            </h1>
            <img alt="" src={require("./images/about_us_grid.png")} width="100%" />
          </div>
          <div className="col-md-6 col-sm-12">
            <h1
              className="heading white-heading desktop-only"
              style={{ padding: "50px 40px 30px 40px" }}
            >
              Custom R&amp;D solutions
            </h1>
            <h2
              className="sub-heading mobile-top-20"
              style={{ fontSize: "1.2em" }}
            >
              At Utvyakta Solutions, we specialize in end-to-end solutions –
              from data acquisition to visualisation using AI to track assets
              anytime, anywhere because we strongly believe that maintenance
              should be proactive and not reactive.
              <br />
              <br />
              We are currently working on developing custom solutions for
              specific use cases to provide a live feed of critical equipment to
              drive increased performance efficiencies and cost savings. Talk to
              us to understand how we can add value to your operations through
              technology.
            </h2>
          </div>
        </div>
      </div> */}

      {/* <div className="container-fluid grey-bg team-panel-bg">
        <div className="container">
          <div className="col-12 text-left brand-heading">Core Team</div>
          <div className="col-12 text-left team-panel">
            <div className="row" style={{ margin: "0 auto" }}>
              <div className="col col-md-4 col-sm-12 team-card">
                <div className="row">
                  <div className="col-10 team-heading">
                    Akshay Ramachandran
                    <a
                      href="https://www.linkedin.com/in/akshay-ramachandran-97515342/"
                      target="_blank"
                      rel="noopener noreferrer"
                      className="team-linkedin-item"
                    >
                      <img
                        alt=""
                        src={require("./images/in_transparent.png")}
                        width="25px"
                      />
                    </a>
                  </div>
                </div>
                <div className="row">
                  <div className="col-4">
                    <img alt="" src={require("./images/team_1.png")} width="100%" />
                  </div>
                  <div className="col-7">
                    <p className="para">
                      Founder &amp; Managing Director with Sales, Management
                      &amp; dev experience across India &amp; Europe{" "}
                    </p>
                  </div>
                </div>
              </div>

              <div className="col col-md-4 col-sm-12 team-card">
                <div className="row">
                  <div className="col-10 team-heading">
                    Sudhir Ravindramohan
                    <a
                      href="https://www.linkedin.com/in/sudhirrpublicprofile/"
                      target="_blank"
                      rel="noopener noreferrer"
                      className="team-linkedin-item"
                    >
                      <img
                        alt=""
                        src={require("./images/in_transparent.png")}
                        width="25px"
                      />
                    </a>
                  </div>
                </div>
                <div className="row">
                  <div className="col-4">
                    <img alt="" src={require("./images/team_2.png")} width="100%" />
                  </div>
                  <div className="col-7">
                    <p className="para">
                      Chief Technology Officer with 15 years of global
                      experience across McWane &amp; Oracle
                    </p>
                  </div>
                </div>
              </div>

              <div className="col col-md-4 col-sm-12 team-card">
                <div className="row">
                  <div className="col-10 team-heading">
                    Frederik Vyncke
                    <a
                      href="https://www.linkedin.com/in/frederikvyncke/"
                      target="_blank"
                      rel="noopener noreferrer"
                      className="team-linkedin-item"
                    >
                      <img
                        alt=""
                        src={require("./images/in_transparent.png")}
                        width="25px"
                      />
                    </a>
                  </div>
                </div>
                <div className="row">
                  <div className="col-4">
                    <img alt="" src={require("./images/team_3.png")} width="100%" />
                  </div>
                  <div className="col-7">
                    <p className="para">
                      Co-Founder &amp; Sales Director with leadership,
                      Investments and sales experience globally
                    </p>
                  </div>
                </div>
              </div>
            </div>

            <div
              className="row"
              style={{ margin: "0 auto", justifyContent: "center" }}
            >
              <div className="col col-md-4 col-sm-12 team-card">
                <div className="row">
                  <div className="col-10 team-heading">
                    Prasanna Raghavan
                    <a
                      href="https://www.linkedin.com/in/prasanna-venkatesh-raghavan-24438222/"
                      target="_blank"
                      rel="noopener noreferrer"
                      className="team-linkedin-item"
                    >
                      <img
                        alt=""
                        src={require("./images/in_transparent.png")}
                        width="25px"
                      />
                    </a>
                  </div>
                </div>
                <div className="row">
                  <div className="col-4">
                    <img alt="" src={require("./images/team_4.png")} width="100%" />
                  </div>
                  <div className="col-7">
                    <p className="para">
                      Director for SI projects with product experience in energy
                      management, automotive telematrics &amp; inventory
                      management
                    </p>
                  </div>
                </div>
              </div>

              <div className="col col-md-4 col-sm-12 team-card">
                <div className="row">
                  <div className="col-10 team-heading">
                    Uma Maheswari V
                    <a
                      href="https://www.linkedin.com/in/uma-maheswari-v-431a96147/"
                      target="_blank"
                      rel="noopener noreferrer"
                      className="team-linkedin-item"
                    >
                      <img
                        alt=""
                        src={require("./images/in_transparent.png")}
                        width="25px"
                      />
                    </a>
                  </div>
                </div>
                <div className="row">
                  <div className="col-4">
                    <img alt="" src={require("./images/team_11.png")} width="100%" />
                  </div>
                  <div className="col-7">
                    <p className="para">
                      Manager HR & Admin with 10+ years experience in HR &
                      Administration
                    </p>
                  </div>
                </div>
              </div>
              
              <div className="col col-md-4 col-sm-12 team-card">
                <div className="row">
                  <div className="col-10 team-heading">
                  Betsy Merin Paul
                    <a
                      href="https://www.linkedin.com/in/betsy-merin-paul-419597106/"
                      target="_blank"
                      rel="noopener noreferrer"
                      className="team-linkedin-item"
                    >
                      <img
                        alt=""
                        src={require("./images/in_transparent.png")}
                        width="25px"
                      />
                    </a>
                  </div>
                </div>
                <div className="row">
                  <div className="col-4">
                    <img alt="" src={require("./images/team_12.png")} width="100%" />
                  </div>
                  <div className="col-7">
                    <p className="para">
                    Operations Manager with 5+ years of 
                    experience in handling content, 
                    communications &amp; associated 
                    projects that aligns with the company's goals.
                    </p>
                  </div>
                </div>
              </div>
            </div>

            <div className="row" style={{ margin: "0 auto" }}>
              <div className="col col-md-4 col-sm-12 team-card">
                <div className="row">
                  <div className="col-10 team-heading">
                    Ashwin Paul
                    <a
                      href="https://www.linkedin.com/in/ashwin-paul-47393430/"
                      target="_blank"
                      rel="noopener noreferrer"
                      className="team-linkedin-item"
                    >
                      <img
                        alt=""
                        src={require("./images/in_transparent.png")}
                        width="25px"
                      />
                    </a>
                  </div>
                </div>
                <div className="row">
                  <div className="col-4">
                    <img src={require("./images/team_8.png")} width="100%" alt="preview"  />
                  </div>
                  <div className="col-7">
                    <p className="para">
                      Sales Head with experience across industries such as
                      Steel,IT & Power health & wearables
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div> */}

      <Footer pageRefs={aboutUsPageRefs} />
    </React.Fragment>
  );
}
export default AboutUs;
